// Lightweight, dependency-free toast — replaces native alert() so notices match
// the app instead of popping a browser dialog. Works from React components,
// redux slices, and plain utils alike (no hook/provider needed), and renders
// correctly inside the embed iframe since it mounts into the current document.

let container = null;

const COLORS = {
  error: "#dc2626",
  success: "#16a34a",
  info: "#334155",
};

function ensureContainer() {
  if (container && document.body.contains(container)) return container;
  container = document.createElement("div");
  container.setAttribute("data-channels-toast", "");
  Object.assign(container.style, {
    position: "fixed",
    zIndex: "2147483000",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    pointerEvents: "none",
    maxWidth: "92vw",
  });
  document.body.appendChild(container);
  return container;
}

/**
 * Show a transient toast notification.
 * @param {string} message
 * @param {"error"|"success"|"info"} [type="info"]
 */
export function toast(message, type = "info") {
  if (!message && message !== 0) return;
  const host = ensureContainer();

  const el = document.createElement("div");
  el.textContent = String(message);
  Object.assign(el.style, {
    pointerEvents: "auto",
    background: COLORS[type] || COLORS.info,
    color: "#fff",
    padding: "10px 16px",
    borderRadius: "10px",
    fontSize: "14px",
    lineHeight: "1.35",
    fontWeight: "500",
    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
    maxWidth: "420px",
    textAlign: "center",
    opacity: "0",
    transform: "translateY(8px)",
    transition: "opacity .18s ease, transform .18s ease",
  });
  host.appendChild(el);

  // animate in
  requestAnimationFrame(() => {
    el.style.opacity = "1";
    el.style.transform = "translateY(0)";
  });

  const remove = () => {
    el.style.opacity = "0";
    el.style.transform = "translateY(8px)";
    setTimeout(() => el.remove(), 200);
  };
  el.addEventListener("click", remove);
  setTimeout(remove, 3500);
}

export default toast;
